export const personalInfo = {
  name: "Vishal Majithia",
  tagline: "Securing the Digital Frontier with Zero‑Trust AI",
  subtitle: "Cybersecurity Leader & Strategist | Building Cyber-Resilient & Future-Ready Enterprises",
  location: "Ahmedabad, Gujarat, India",
  email: "connect@vishalmajithia.com",
  connections: "1.5K+",
  yearsExperience: "11+",
  profilePhoto: "https://customer-assets.emergentagent.com/job_quantum-defense-2/artifacts/nhgfdtm2_Vishal%20Majithia%20Image.jpg",
  socialLinks: {
    linkedin: "https://linkedin.com/in/iamvsm",
    github: "https://github.com/iamvsm",
    x: "https://x.com/IamVSM",
    youtube: "https://www.youtube.com/@CyberWithVishal",
    instagram: "https://www.instagram.com/cyberwithvishal/",
    facebook: "https://www.facebook.com/IamVSM",
    telegram: "https://t.me/iamvsm",
    discord: "https://discord.gg/ZSDu77DZ",
    threads: "https://www.threads.net/@iamvsm.x",
    pinterest: "https://pinterest.com/3wBZu1baD",
    snapchat: "https://www.snapchat.com/add/iamvsm",
    saraswatiRepo: "https://saraswatirepository.com/",
    cyberWithVishal: "https://cyberwithvishal.com/",
    linktree: "https://linktr.ee/iamvsm"
  }
};

export const aboutData = {
  summary: `I am a cybersecurity leader with 11+ years of experience strengthening enterprise-wide security, resilience, and risk programs across global and highly regulated environments. My career includes leadership roles at Intas Pharmaceuticals, IBM, Wipro, Infibeam, Microlink Solutions, ISRO, and academic institutions — experience that provides a complete viewpoint on security operations at scale.`,
  mission: `Build cyber-resilient, future-ready organizations capable of defending and adapting in a rapidly evolving threat landscape.`,
  highlight: `At INTAS Group companies — including Accord Healthcare, Lambda-CRO, Novum PRS — I lead cybersecurity strategy, security architecture, cyber-defense modernization, incident-readiness, and enterprise risk programs as Senior Manager IT Security Risk & Compliances.`,
  strengths: [
    "Enterprise Cyber-Resilience",
    "Cyber Risk Management & Governance",
    "Cybersecurity Strategist",
    "Policy & Governance",
    "Threat Detection & Response",
    "Red Teaming",
    "Crisis Management",
    "Cloud & Identity Security",
    "Zero Trust Architecture",
    "Next-Gen Security Platforms"
  ],
  philosophy: `I believe in business-aligned cybersecurity that strengthens resilience while enabling trust, innovation, and operational continuity. I also lead Cyber With Vishal, a platform dedicated to sharing advanced cybersecurity insights with the broader community.`
};

export const experienceData = [
  {
    id: 1,
    role: "Senior Manager — IT Security, Risk & Compliances",
    company: "INTAS Group Companies (INTAS, Accord Healthcare, Lambda‑CRO, Novum PRS)",
    period: "Apr 2025 – Present",
    location: "Ahmedabad, India",
    description: "Own the end‑to‑end Cybersecurity & Information Security mandate for the group: cyber resilience, SecOps/SOC, security engineering & architecture, governance, risk & compliance (GRC), privacy, red/blue/purple team programs, DFIR, AppSec, cloud & identity security, data protection, OT/IoT security, and AI governance.",
    bullets: [
      "SecOps, SOC & DFIR: XDR/SIEM/SOAR roadmap; detection engineering and hunt ops; incident orchestration and evidence‑first RCA; continuous content tuning to reduce MTTD/MTTR.",
      "Security engineering & architecture: Zero‑Trust designs across identity, device, network, app, and data; NGFW/WAF/proxy/LB/CDN, DDoS, NIPS/HIPS, SSL orchestration; deception for crown‑jewel zones.",
      "Cloud: Multi‑cloud guardrails (Azure/AWS/GCP) with CSPM/CNAPP, workload baselines, KMS/secrets, and IaC controls.",
      "Data & identity: Advanced email security; DLP/DSPM; PIM/PAM, Conditional Access, JIT/JEA; enterprise browser, MDM/BYOD; data minimization and least‑privilege by design.",
      "AI governance (Zero‑Trust AI): Allow‑listed enterprise AI (e.g., M365 Copilot), prompt/data‑loss controls, content filters, residency & lineage, per‑prompt audit trails, and human‑in‑the‑loop for sensitive actions.",
      "GRC & privacy: DPDPA/GDPR‑aligned policy → control → audit evidence; DPIAs, vendor due diligence/DPAs, risk registers, board‑level reporting; regulator‑ready documentation."
    ],
    current: true
  },
  {
    id: 2,
    role: "Manager — IT Security, Risk & Compliances",
    company: "INTAS Group Companies (INTAS, Accord Healthcare, Lambda‑CRO, Novum PRS)",
    period: "May 2023 – Apr 2025",
    location: "Ahmedabad, India",
    description: "Established the foundational control stack and operating rhythms: SOC uplift (XDR/SIEM/SOAR), email/data protection (DLP/DSPM, sensitivity labels), identity hardening (PIM/PAM, Conditional Access), and CSPM/CNAPP for baseline cloud posture.",
    bullets: [
      "Instituted governance cadences (policy lifecycle, risk registers, control testing), incident playbooks, and evidence‑first reporting to leadership/regulators."
    ],
    current: false
  },
  {
    id: 3,
    role: "Cyber Security Consultant",
    company: "IBM",
    period: "Jan 2022 – Apr 2023",
    location: "Pune, India",
    description: "Led SecOps, SOC Engineering & DFIR for enterprise accounts: detection engineering, SIEM/XDR content tuning, SOAR playbooks, triage & incident orchestration, and post‑incident RCA with remediation tracking.",
    bullets: [
      "Built purple‑team feedback loops and BAS validations to increase true‑positive fidelity; drove measurable MTTD/MTTR improvements.",
      "Delivered advisory on framework alignment (NIST/ISO, SOX, HIPAA, PCI‑DSS) and control hardening across hybrid environments."
    ],
    current: false
  },
  {
    id: 4,
    role: "Cyber Security Lead",
    company: "Wipro",
    period: "Mar 2021 – Dec 2021",
    location: "Pune, India",
    description: "Led cybersecurity operations and strategy uplift across business units; formalized policy enforcement, detection engineering pipelines, incident runbooks, and executive reporting.",
    bullets: [
      "Coordinated identity hardening (PIM/PAM, Conditional Access), enhanced email/data controls (DLP, label‑driven policies), and improved SIEM content hygiene."
    ],
    current: false
  },
  {
    id: 5,
    role: "Sr. Network & Security Lead",
    company: "Infibeam",
    period: "Mar 2020 – Mar 2021",
    location: "Gandhinagar, India",
    description: "Owned high‑scale e‑commerce/fintech network & security operations: perimeter and application security (NGFW, WAF, proxies, LB, CDN, DDoS, SSL orchestration), segmentation, and availability engineering.",
    bullets: [
      "Drove logging/telemetry normalization and response workflows; tightened change control and evidence packs for audits."
    ],
    current: false
  },
  {
    id: 6,
    role: "Sr. Network & Security Lead — Technical SME Lead",
    company: "Microlink Solutions Pvt. Ltd.",
    period: "2017 – 2020",
    location: "India",
    description: "Technical SME leading multi‑client enterprise network & security designs: routing/switching, VPNs, wireless, NGFW/WAF, segmentation, and identity‑aware access.",
    bullets: [
      "Delivered migration playbooks, hardening baselines, and runbooks for operations teams; mentored engineers and established review cadences."
    ],
    current: false
  },
  {
    id: 7,
    role: "Sr. Network & Security Lead — Technical SME Lead",
    company: "ISRO (Indian Space Research Organisation)",
    period: "2017 – 2019",
    location: "India",
    description: "Supported mission‑critical networks & security as Technical SME: core routing/switching, secure inter‑site connectivity, segmentation for sensitive domains, and monitoring/playbooks for reliability and assurance.",
    bullets: [
      "Coordinated change windows and validations with engineering/operations for minimal downtime and consistent evidence capture."
    ],
    current: false
  },
  {
    id: 8,
    role: "Network Security Lead",
    company: "RK University",
    period: "2015 – 2017",
    location: "India",
    description: "Led network security operations & IT infrastructure: perimeter defenses, policy enforcement, identity/access controls, wireless posture, backup/DR drills, and end‑user awareness.",
    bullets: [
      "Implemented monitoring and incident response workflows appropriate to academic operations and compliance expectations."
    ],
    current: false
  }
];

export const skillsData = [
  {
    category: "Cyber Defense",
    skills: [
      { name: "Threat Detection & Response", level: 95 },
      { name: "Incident Response & Forensics", level: 92 },
      { name: "Red Teaming & Pentesting", level: 88 },
      { name: "Vulnerability Assessment", level: 94 }
    ]
  },
  {
    category: "Architecture & Strategy",
    skills: [
      { name: "Zero Trust Architecture", level: 93 },
      { name: "Cloud Security (AWS/Azure)", level: 90 },
      { name: "Identity & Access Management", level: 91 },
      { name: "Security Architecture Design", level: 94 }
    ]
  },
  {
    category: "Governance & Risk",
    skills: [
      { name: "Cyber Risk Management & Governance", level: 96 },
      { name: "Cyber Resilience", level: 95 },
      { name: "Compliance (ISO 27001/NIST)", level: 95 },
      { name: "Cybersecurity Strategy", level: 94 },
      { name: "Crisis Management", level: 90 }
    ]
  },
  {
    category: "AI & Innovation",
    skills: [
      { name: "AI-Driven Defense Strategies", level: 87 },
      { name: "SIEM & SOAR Platforms", level: 91 },
      { name: "Next-Gen Security Platforms", level: 89 },
      { name: "Threat Intelligence", level: 92 }
    ]
  }
];

export const portfolioData = [
  {
    id: 1,
    title: "Enterprise Zero Trust Implementation",
    category: "Architecture",
    description: "Designed and deployed a comprehensive Zero Trust security architecture across a multi-national pharmaceutical enterprise, reducing attack surface by 73%.",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop",
    tags: ["Zero Trust", "Enterprise", "Architecture"],
    metrics: { impact: "73% attack surface reduction", scale: "15,000+ endpoints" }
  },
  {
    id: 2,
    title: "AI-Powered Threat Detection System",
    category: "AI & Defense",
    description: "Built an AI-driven threat detection platform that processes millions of security events in real-time, achieving 99.2% detection accuracy with ML-based anomaly detection.",
    image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=600&h=400&fit=crop",
    tags: ["AI/ML", "Threat Detection", "SIEM"],
    metrics: { impact: "99.2% detection accuracy", scale: "10M+ events/day" }
  },
  {
    id: 3,
    title: "Cloud Security Modernization",
    category: "Cloud Security",
    description: "Led cloud security transformation for hybrid infrastructure, implementing CSPM, CWPP, and automated compliance monitoring across AWS and Azure environments.",
    image: "https://images.unsplash.com/photo-1568952433726-3896e3881c65?w=600&h=400&fit=crop",
    tags: ["Cloud", "AWS", "Azure", "CSPM"],
    metrics: { impact: "98% compliance score", scale: "500+ cloud workloads" }
  },
  {
    id: 4,
    title: "Cyber With Vishal - Knowledge Platform",
    category: "Thought Leadership",
    description: "Founded and lead 'Cyber With Vishal', a YouTube and blog platform sharing advanced cybersecurity insights, tutorials, and industry analysis with the broader community.",
    image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?w=600&h=400&fit=crop",
    tags: ["Education", "YouTube", "Community"],
    metrics: { impact: "Growing community", scale: "100+ tutorials" }
  },
  {
    id: 5,
    title: "Incident Response Framework",
    category: "Operations",
    description: "Developed and implemented a comprehensive incident response framework with automated playbooks, reducing mean time to respond (MTTR) by 65% across the organization.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop",
    tags: ["IR", "SOAR", "Automation"],
    metrics: { impact: "65% MTTR reduction", scale: "24/7 SOC coverage" }
  },
  {
    id: 6,
    title: "Saraswati Repository",
    category: "Research",
    description: "Created and maintain Saraswati Repository — a comprehensive knowledge base for cybersecurity strategy, research papers, and advanced security methodologies.",
    image: "https://images.pexels.com/photos/5473955/pexels-photo-5473955.jpeg?w=600&h=400&fit=crop",
    tags: ["Research", "Knowledge Base", "Strategy"],
    metrics: { impact: "Open knowledge", scale: "Global reach" }
  }
];

export const blogData = [
  {
    id: 1,
    title: "Claude Distillation Attack: When AI Intelligence Is Copied Without Hacking",
    date: "February 25, 2026",
    excerpt: "Artificial Intelligence security is entering a new phase. Not through malware, exploits, or data breaches — but through intelligence extraction.",
    link: "https://saraswatirepository.com/strategy/claude-distillation-attack-ai-intelligence-copied-without-hacking/",
    category: "AI Security",
    readTime: "8 min read"
  },
  {
    id: 2,
    title: "The Year of the Evasive Adversary: What the CrowdStrike 2026 Threat Report Reveals",
    date: "February 24, 2026",
    excerpt: "The CrowdStrike 2026 Global Threat Report identifies 2025 as the year of the evasive adversary, a period where attackers moved faster than defenses.",
    link: "https://saraswatirepository.com/strategy/year-of-the-evasive-adversary-crowdstrike-2026-threat-report/",
    category: "Threat Intelligence",
    readTime: "10 min read"
  },
  {
    id: 3,
    title: "Dark Web 2025: The Underground Economy That Powers Modern Cybercrime",
    date: "February 7, 2026",
    excerpt: "The dark web has evolved from a shadowy underworld into a sophisticated, accessible marketplace where cybercrime tools are available at lower prices.",
    link: "https://saraswatirepository.com/strategy/dark-web-2025-underground-economy-modern-cybercrime/",
    category: "Strategy",
    readTime: "8 min read"
  },
  {
    id: 4,
    title: "Next-Gen Identity Security: Why 'Logging In' Is the New Breach Vector",
    date: "February 3, 2026",
    excerpt: "Cybersecurity has crossed a decisive inflection point. Attackers are no longer forcing entry through malware-heavy intrusions or perimeter exploits.",
    link: "https://saraswatirepository.com/strategy/next-gen-identity-security-logging-in-is-the-new-breach-vector/",
    category: "Identity Security",
    readTime: "7 min read"
  },
  {
    id: 5,
    title: "Cybersecurity Landscape – January 2026: Threats, Breaches, Regulations & Leadership",
    date: "February 2, 2026",
    excerpt: "A comprehensive landscape overview covering threats, breaches, regulations and leadership priorities shaping the cybersecurity ecosystem.",
    link: "https://saraswatirepository.com/strategy/cybersecurity-landscape-january-2026/",
    category: "Strategy",
    readTime: "12 min read"
  },
  {
    id: 6,
    title: "Cybersecurity 2026: A New Era of Velocity, Industrialization & Machine-Speed Warfare",
    date: "January 16, 2026",
    excerpt: "Cybersecurity in 2026 has broken from its past. There are no longer distinct boundaries between offense and defense in the machine-speed era.",
    link: "https://saraswatirepository.com/strategy/cybersecurity-2026-ai-threat-landscape-strategy/",
    category: "AI & Cybersecurity",
    readTime: "10 min read"
  },
  {
    id: 7,
    title: "AI Everywhere, Trust Nowhere – Enterprise Security Lessons from ThreatLabz 2025 Report",
    date: "January 7, 2026",
    excerpt: "Artificial Intelligence has silently crossed a threshold. What started as experimental tooling is now embedded in enterprise operations at scale.",
    link: "https://saraswatirepository.com/strategy/ai-everywhere-trust-nowhere-threatlabz-2025-ai-security-report/",
    category: "AI Security",
    readTime: "9 min read"
  },
  {
    id: 8,
    title: "Cybersecurity Forecast 2026: When Intelligence Becomes the Battlefield",
    date: "January 7, 2026",
    excerpt: "In 2026, cybersecurity will no longer be defined by tools alone — but by intelligence, identity, and intent.",
    link: "https://saraswatirepository.com/strategy/cybersecurity-forecast-2026-2/",
    category: "Strategy",
    readTime: "8 min read"
  },
  {
    id: 9,
    title: "The Cost of a Data Breach in 2025: When AI Moves Faster Than Governance",
    date: "January 7, 2026",
    excerpt: "For the first time in five years, the global cost of a data breach has declined. At USD 4.44 million, this drop appears promising but masks deeper risks.",
    link: "https://saraswatirepository.com/strategy/cost-of-a-data-breach-2025-ai-oversight-gap/",
    category: "GRC",
    readTime: "9 min read"
  },
  {
    id: 10,
    title: "Cybersecurity in 2026: The Year AI Reshapes Risk, Defense & Global Digital Trust",
    date: "January 6, 2026",
    excerpt: "As we enter 2026, cybersecurity is no longer just a technical challenge — it has become a strategic imperative for every business.",
    link: "https://saraswatirepository.com/strategy/cybersecurity-trends-2026-ai-agentic-defense/",
    category: "AI & Cybersecurity",
    readTime: "11 min read"
  }
];

export const statsData = [
  { label: "Years Experience", value: "11+" },
  { label: "Enterprises Secured", value: "20+" },
  { label: "Security Projects", value: "50+" },
  { label: "Community Reach", value: "1.5K+" }
];

export const shortFilmData = {
  title: "The Last Line of Defence",
  subtitle: "CyberDefense Short Film",
  description: "A cinematic journey into the world of cybersecurity — exploring the human stories behind digital defense and the relentless pursuit of protecting what matters most.",
  instagramLink: "https://www.instagram.com/cyberwithvishal/reel/DSsWVQxE7fi/",
  youtubeLink: "https://www.youtube.com/watch?v=DkAxYycA2F0",
  thumbnail: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800&h=450&fit=crop"
};

export const educationData = [
  {
    degree: "Bachelor of Engineering - BE, Computer Science",
    institution: "Atmiya Institute of Technology & Science, Rajkot",
    period: "2009 – 2013"
  }
];

export const certificationsData = [
  {
    category: "Leadership & Strategy",
    certs: [
      { name: "Certified Chief Information Security Officer (CCISO)", issuer: "EC-Council", icon: "shield" },
      { name: "SANS SEC 411", issuer: "SANS Institute", icon: "shield" },
    ]
  },
  {
    category: "Cybersecurity & Offensive",
    certs: [
      { name: "(ISC)² Certified in Cybersecurity (CC)", issuer: "ISC2", date: "Jul 2024 – Jul 2027", credId: "1681892", icon: "lock" },
      { name: "Certified Ethical Hacker (CEH)", issuer: "EC-Council", date: "Apr 2021", credId: "ECC6874531902", icon: "lock" },
      { name: "Web Application Hacking & Security", issuer: "EC-Council", icon: "lock" },
      { name: "Dark Web Hunting", issuer: "SOCRadar® Extended Threat Intelligence", date: "Jun 2024", credId: "6662a79f2d081c710c04372d", icon: "lock" },
      { name: "Stealth Penetration Testing with Advanced Enumeration", issuer: "LinkedIn", date: "Dec 2023", icon: "lock" },
      { name: "(ISC)² Candidate", issuer: "ISC2", date: "Dec 2022", credId: "1681892", icon: "lock" },
    ]
  },
  {
    category: "Network Security",
    certs: [
      { name: "CCNP (Cisco Certified Network Professional)", issuer: "Cisco", icon: "network" },
      { name: "CCNA (Cisco Certified Network Associate)", issuer: "Cisco", date: "May 2019", credId: "CSCO13461923", icon: "network" },
      { name: "Palo Alto Networks Certified Network Security Engineer", issuer: "Palo Alto Networks", date: "Sep 2020", credId: "M6ZQ2FW2DMFE1R9T", icon: "network" },
      { name: "Palo Alto Networks Certified Network Security Administrator", issuer: "Palo Alto Networks", date: "Aug 2020", credId: "2YJSWZTKDMREQK55", icon: "network" },
      { name: "Fortinet NSE 4 Network Security Professional", issuer: "Fortinet", date: "Jun 2019", credId: "1ZE7SH8tpC", icon: "network" },
      { name: "Fortinet NSE 3 Network Security Associate", issuer: "Fortinet", date: "May 2019", credId: "ZO5d4ZsaKn", icon: "network" },
      { name: "Fortinet NSE 2 Network Security Associate", issuer: "Fortinet", date: "May 2019", credId: "USx22lJsZV", icon: "network" },
      { name: "Fortinet NSE 1 Network Security Associate", issuer: "Fortinet", date: "May 2019", credId: "MYhqUxEjxO", icon: "network" },
    ]
  },
  {
    category: "Governance & Recognition",
    certs: [
      { name: "Bharat Vikas Pledge", issuer: "Government of Gujarat", date: "Oct 2024", icon: "award" },
      { name: "Certificate of Commitment", issuer: "Central Vigilance Commission - India", date: "Jul 2017", icon: "award" },
    ]
  }
];

export const networkTags = [
  "Network Security Architects",
  "Cyber Security Engineers",
  "Cyber Security Consultants",
  "IBM Cyber Security",
  "IT Infrastructure Managers"
];
